import { CharacterEnum } from '../../enums/character.enum';
import { CompanyLogoAndNameResponse } from '../../models/fundamental/types';

export const COMPANY_LOGO_AND_NAME_SYMBOL_LIMIT = 80;

export const getCompanyLogoAndNameSymbolBatches = (
  symbols: string,
  batchSize: number = COMPANY_LOGO_AND_NAME_SYMBOL_LIMIT,
): string[] => {
  if (!symbols) {
    return [];
  }

  const symbolList = symbols
    .split(CharacterEnum.Comma)
    .map(symbol => symbol.trim())
    .filter(Boolean);

  const batches: string[] = [];

  for (let index = 0; index < symbolList.length; index += batchSize) {
    batches.push(symbolList.slice(index, index + batchSize).join(CharacterEnum.Comma));
  }

  return batches;
};

export const mergeCompanyLogoAndNameResponses = (
  responses: CompanyLogoAndNameResponse[][],
): CompanyLogoAndNameResponse[] => {
  const mergedResponses = new Map<string, CompanyLogoAndNameResponse>();

  responses.flat().forEach(response => {
    mergedResponses.set(response.symbol, response);
  });

  return Array.from(mergedResponses.values());
};
